/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ListPolicyRecommendationsResponse {
    getFixupPrototypeFunction() { return ListPolicyRecommendationsResponse.fixupPrototype; }

    static newInstance(model: Partial<ListPolicyRecommendationsResponse>): ListPolicyRecommendationsResponse {
        let obj = Object.assign(new ListPolicyRecommendationsResponse(), model);
        ListPolicyRecommendationsResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ListPolicyRecommendationsResponse>): ListPolicyRecommendationsResponse {
        if (!model) return null;
        return ListPolicyRecommendationsResponse.newInstance(<ListPolicyRecommendationsResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ListPolicyRecommendationsResponse) {
        if (!obj) return;

        models.ListPolicyRecommendationsResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ListPolicyRecommendationsResponse): boolean {
        Object.setPrototypeOf(obj, ListPolicyRecommendationsResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.total_count === undefined) {
            this.total_count = 0;
        }
        if (this.page_count === undefined) {
            this.page_count = 0;
        }
        if (this.resource_counts) {
            models.ResourceCount.fixupPrototype(this.resource_counts);
        }
        if (this.actions) {
            for (let val of this.actions) {
                models.ActionDetails.fixupPrototype(val);
            }
        }
    }

    /**
     * Policy ID
     */
    policy_id: Array<string>;

    /**
     * Policy Name
     */
    policy_name: string;

    /**
     * Policy Description
     */
    policy_description: string;

    /**
     * Name of the policy recommendation
     */
    name: string;

    /**
     * Status
     */
    status: string;

    /**
     * Impact
     */
    impact: string;

    /**
     * Oscar Classification
     */
    classification: string;

    /**
     * Sub classification of the above classification
     */
    sub_classification: string;

    /**
     * Cloud Account ID
     */
    cloud_account_id: string;

    /**
     * Cloud Account Name
     */
    cloud_account_name: string;

    /**
     * Cloud Service Name
     */
    service_name: string;

    /**
     * Tenant Name
     */
    tenant_name: string;

    /**
     * Time of creation
     */
    created_at: string;

    /**
     * Count of the resource that are open
     */
    resource_counts: models.ResourceCount;

    /**
     * Description of the policy
     */
    description: string;

    /**
     * Action to be taken for that policy recommendation
     */
    actions: Array<models.ActionDetails>;

    /**
     * Total count
     */
    total_count: number;

    /**
     * Page count
     */
    page_count: number;

    /**
     * Resources Details
     */
    resources: Array<any>;

}
